module.exports = __webpack_public_path__ + "img/Pic_ShutDown.f6aff17e.png";